import { Card } from "antd";
import React from "react";
import { CircleCheck, CircleX } from "lucide-react";
import { Icon } from "src/components/icons/Icon";
import {
	IUserTrainingCourseSectionSummary,
	IUserTrainingCourseSummary,
	IUserTrainingSummary,
} from "src/@types/ImpiricaPlatformApi";
import ResyncTrainingButton from "src/admin/Organization/Users/ResyncTrainingButton";
import TrainingSummarySection from "./TrainingSummarySection";
import styles from "./TrainingSummaryCourse.module.scss";

type TrainingSummaryCoursesProps = {
	organizationId: number;
	userId: number;
	courseDetails: IUserTrainingSummary;
};

const TrainingSummaryCourse: React.FC<TrainingSummaryCoursesProps> = ({
	organizationId,
	userId,
	courseDetails,
}) => {
	return (
		<div className={styles.container}>
			<div className={styles.reCheckAllButtonContainer}>
				<ResyncTrainingButton
					organizationId={organizationId}
					userId={userId}
					onSynced={() => window.location.reload()}
				/>
			</div>
			<div className={styles.cardContainer}>
				{courseDetails &&
					courseDetails.courses &&
					courseDetails.courses.map((course: IUserTrainingCourseSummary) => {
						return (
							<Card
								key={course.courseId}
								className={styles.card}
								title={
									<div className={styles.titleContainer}>
										<p className={styles.title}>{course.title}</p>
										{course.courseComplete ? (
											<Icon
												icon={CircleCheck}
												size="lg"
												color="#52c41a"
												className={styles.icon}
											/>
										) : (
											<Icon
												icon={CircleX}
												size="lg"
												color="#eb2f96"
												className={styles.icon}
											/>
										)}
									</div>
								}
							>
								<div className={styles.cardBody}>
									{course.sections &&
										course.sections.map(
											(
												section: IUserTrainingCourseSectionSummary,
												index: number
											) => (
												<TrainingSummarySection section={section} key={index} />
											)
										)}
									{course.quizId && (
										<span className={styles.quizTitle}>
											Quiz{" "}
											{course.quizComplete ? (
												<Icon
													icon={CircleCheck}
													size="lg"
													color="#52c41a"
													className={styles.icon}
												/>
											) : (
												<Icon
													icon={CircleX}
													size="lg"
													color="#eb2f96"
													className={styles.icon}
												/>
											)}
										</span>
									)}
								</div>
							</Card>
						);
					})}
			</div>
		</div>
	);
};

export default TrainingSummaryCourse;
